var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignInLandingPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99992 6.66666V4.66666C2.99992 3.60579 3.42135 2.58837 4.17149 1.83823C4.92164 1.08808 5.93905 0.666656 6.99992 0.666656C8.06078 0.666656 9.0782 1.08808 9.82835 1.83823C10.5785 2.58837 10.9999 3.60579 10.9999 4.66666V6.66666H11.6666C12.7712 6.66666 13.6666 7.56209 13.6666 8.66666V13.3333C13.6666 14.4379 12.7712 15.3333 11.6666 15.3333H2.33325C1.22868 15.3333 0.333252 14.4379 0.333252 13.3333V8.66666C0.333252 7.56209 1.22868 6.66666 2.33325 6.66666H2.99992ZM5.1143 2.78104C5.6144 2.28094 6.29268 1.99999 6.99992 1.99999C7.70716 1.99999 8.38544 2.28094 8.88554 2.78104C9.38563 3.28114 9.66659 3.95941 9.66659 4.66666V6.66666H4.33325V4.66666C4.33325 3.95941 4.6142 3.28114 5.1143 2.78104ZM2.33325 7.99999C1.96506 7.99999 1.66659 8.29847 1.66659 8.66666V13.3333C1.66659 13.7015 1.96506 14 2.33325 14H11.6666C12.0348 14 12.3333 13.7015 12.3333 13.3333V8.66666C12.3333 8.29847 12.0348 7.99999 11.6666 7.99999H2.33325Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInLandingPage);
export default __webpack_public_path__ + "static/media/sign-in-landing-page.2a7692c7.svg";
export { ForwardRef as ReactComponent };